class MailGroupId {
  constructor(private readonly _value: number = NaN) {
  }

  public equals(other: MailGroupId): boolean {
    return this._value === other.value;
  }

  public notEquals(other: MailGroupId): boolean {
    return this._value !== other.value;
  }

  get value() {
    return this._value;
  }
}

export default MailGroupId;
